var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"image-div"}),_c('app-header'),(_vm.connectionFailed)?_c('app-alert',{attrs:{"message":'Connection failed!',"type":'danger'}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }